import { parse as parseQueryString } from 'query-string';

const { search } = window.location;
const { redirectUrl, widget, url } = parseQueryString(search);
const agendaRegexp = /^\/([\d]+)\/agenda\/(\w+)\/([\d]+)/;

export const getRedirectUrl = () => {
    if (widget && url) {
        const path = window.location.pathname;
        if (agendaRegexp.test(path)) {
            const [, , page, id] = path.match(agendaRegexp);
            return `${url}?agendaPath=${page}/${id}`;
        }
        return url;
    }
    if (redirectUrl) {
        return redirectUrl;
    }
    return window.location.href;
};
